import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  GonvarriChapaQuantityComponent
} from "../../components/gonvarri-chapa-quantity/gonvarri-chapa-quantity.component";
import {CmsConfig, I18nModule, provideConfig} from "@spartacus/core";
import {FormsModule} from "@angular/forms";

@NgModule({
  declarations: [
    GonvarriChapaQuantityComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    FormsModule
  ],
  exports: [
    GonvarriChapaQuantityComponent
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        GonvarriChapaQuantityComponent: {
          component: GonvarriChapaQuantityComponent
        }
      }
    })
  ]
})
export class GonvarriChapaQuantityModule { }
